import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "../FIREBASE/useAuth";
import { loadCredentials, saveCredentials } from "../FIREBASE/userSettings";
import { setIntervalsCreds } from "../FIREBASE/intervals";
import { ConnectView } from "../VIEW/ConnectView";
import routeUrls from "../COMPONENTS/navbar/navLink";

function ConnectPage() {
  const { user, loading } = useAuth();
  const history = useHistory();
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState("");

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!loading && !user) {
      history.replace(`${routeUrls.LOGIN}?from=${routeUrls.CONNECT}`);
    }
  }, [user, loading, history]);

  // If credentials already exist, skip straight to training
  useEffect(() => {
    if (!user) return;
    loadCredentials(user.uid).then(creds => {
      if (creds) {
        setIntervalsCreds(creds.apiKey, creds.athleteId);
        history.replace(routeUrls.TRAINING);
      }
    });
  }, [user, history]);

  async function handleSave(apiKey: string, athleteId: string) {
    if (!user) return;
    setSaving(true);
    setError("");
    try {
      await saveCredentials(user.uid, { apiKey, athleteId });
      setIntervalsCreds(apiKey, athleteId);
      history.push(routeUrls.TRAINING);
    } catch {
      setError("Kunde inte spara. Kontrollera att du är inloggad och försök igen.");
    } finally {
      setSaving(false);
    }
  }

  if (loading || !user) return null;

  return <ConnectView saving={saving} error={error} onSave={handleSave} />;
}

export default ConnectPage;
